import { RRule } from 'rrule';
import { CreateDueRemainderRequest, CreateTaskRequest, ReminderMode } from 'compliance-api';

export const sanitizeTaskReminders = <T extends CreateTaskRequest>(reportData: T): T => {
  if (!reportData.due_remainders || !reportData.due_remainders.length) return reportData;

  const due_remainders: CreateDueRemainderRequest[] = [];

  for (const reminder of reportData.due_remainders) {
    const mode = reminder.mode ?? ReminderMode.Recurring;

    if (mode === ReminderMode.FixedInterval) {
      due_remainders.push({
        is_when_overdue: true,
        mode: ReminderMode.FixedInterval,
        days_before_due: 0,
        interval_days: reminder.interval_days,
        iterations: reminder.iterations,
      });
      continue;
    }

    if (!reminder.frequency) continue;

    const {
      options: { freq },
    } = RRule.fromString(reminder.frequency);

    if (!freq) continue;

    due_remainders.push({
      is_when_overdue: reminder.is_when_overdue,
      mode: ReminderMode.Recurring,
      days_before_due: reminder.days_before_due,
      frequency: reminder.frequency,
      stop_after: reminder.stop_after,
    });
  }

  return { ...reportData, due_remainders };
};
